import { AfterViewInit, Component, Injector } from "@angular/core";
import { AppComponentBase } from "@shared/common/app-component-base";

@Component({
    templateUrl:"./header.component.html",
    selector:"qrmena-header",
    styleUrls:["./header.component.css"]
})
export class QrMenaHeader extends AppComponentBase implements AfterViewInit{
   
      constructor(injector: Injector, ) {
            super(injector);
           
        }
    ngAfterViewInit(): void {
       //this.setTenantName()
    }
    
}


// WEBPACK FOOTER //
// ./src/QrMena/components/header/header.component.ts